import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject, Subject } from "rxjs";
import { UserEditPopupService } from "./userEditPopup.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-userEditPopup",
  templateUrl: "./userEditPopup.component.html",
  styleUrls: ["./userEditPopup.component.scss"],
})
export class UserEditPopupComponent implements OnInit {
  selectedCategories: any[] = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'product_category',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  outletSetting = {
    singleSelection: true,
    enableCheckAll: false,
    idField: 'id',
    textField: 'displayName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  userForm: FormGroup;
  submitted = false;
  isLoading: Subject<boolean> = new Subject<boolean>();
  mspinList: any[] = [];
  isSales = false;
  isAreaRole: boolean = false;
  isRegionRole: boolean = false;
  dropdownSettingsRegion = {
    singleSelection: false,
    enableCheckAll: false,
    idField: 'id',
    textField: 'region_name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettingsArea = {
    singleSelection: false,
    enableCheckAll: false,
    idField: 'id',
    textField: 'area_name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  constructor(
    private usereditpopupservice: UserEditPopupService,
    public dialogRef: MatDialogRef<UserEditPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {
    console.log("userrr:", data.userData)
    this.isAreaRole = data.userData.role_id == 8 ? true : false;
    this.isRegionRole = data.userData.role_id == 7 ? true : false;
    this.userForm = this.fb.group({
      first_name: [data.userData.first_name, Validators.required],
      last_name: [data.userData.last_name],
      email: [
        { value: data.userData.email, disabled: false },
        [Validators.required, Validators.email],
      ],
      mobile: [
        data.userData.mobile,
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.maxLength(10),
        ],
      ],
      role_id: [{ value: data.userData.role_id, disabled: true }, Validators.required],
      outlet_id: [data?.userData?.outlet_id ? [{ id: data?.userData?.outlet_id, displayName: data?.userData?.outlet?.outlet_name + ' - ' + data?.userData?.outlet?.outlet_code }] : []],
      product_category: [data.userData.product_categories.map((cat: any) => ({
        id: cat.id,
        product_category: cat.product_category
      })) || []],
      area_id: [data.userData.areas || []],
      region_id: [data.userData.regions || []],
      status: [data.userData.status == true ? 1 : 0, Validators.required],
      is_verified: data.userData.is_verified_by_user
    });
    this.initializeMastersData();
    this.loadMSPINList();
    this.selectedRoleId = data.userData.role_id;
    if (this.selectedRoleId === 3) {
      this.userForm.get('outlet_id')?.setValidators([Validators.required]);
      this.userForm.get('product_category')?.setValidators([Validators.required]);
    } else {
      this.userForm.get('outlet_id')?.clearValidators();
      this.userForm.get('product_category')?.clearValidators();
    }

    this.userForm.get('product_category')?.updateValueAndValidity();

  }
  statusList = [{ id: 1, name: "Active" }, { id: 0, name: "Inactive" }];

  ngOnInit() {
    // setTimeout(()=>{
    //   this.initializeMastersData();
    // },2000)
    // setTimeout(()=>{
    //   this.filterProdCat(outletId);
    // },2100)
    const outletId = this.userForm?.value;
    console.log(outletId, 'outletId');

    this.filterProdCat();
  }

  get f() {
    return this.userForm.controls;
  }

  // onSubmit() {
  //   this.submitted = true;
  //   if (this.userForm.valid) {
  //     this.dialogRef.close(this.userForm.getRawValue());
  //   }
  // }

  onSubmit() {
    this.submitted = true;
    if (this.isAreaRole && this.userForm.value?.area_id?.length == 0) {
      this.toastr.error('Please select area!')
    }
    if (this.isRegionRole && this.userForm.value?.region_id?.length == 0) {
      this.toastr.error('Please select region!')
    }
    if (this.userForm.valid) {
      const productCategories = this.userForm.get('product_category')?.value.map((cat: any) => cat.id.toString()) || [];

      const formData = {
        ...this.userForm.getRawValue(),
        outlet_id: this.userForm.value?.outlet_id.length > 0 ? this.userForm.value?.outlet_id[0].id : null,
        status: this.userForm.value.status == 1 ? true : false,
        region_id: this.userForm.value?.region_id ? this.userForm.value?.region_id?.map((item: any) => item.id) : [],
        area_id: this.userForm.value?.area_id ? this.userForm.value?.area_id?.map((item: any) => item.id) : [],
        product_category: productCategories,
        is_verified: this.userForm.value?.is_verified
      };

      this.dialogRef.close(formData);
    }
  }


  onClose(): void {
    this.dialogRef.close();
  }

  keyPress(event: KeyboardEvent) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  selectedRoleId: number | null = null; // To store selected role ID
  filteredProdCat: any[] = []; // To store filtered product categories  
  roleValue: any = []
  prodCat: any = []
  prodOut: any = []
  areaValue: any = [];
  regionValue: any = [];
  initializeMastersData() {
    const mastersSession = sessionStorage.getItem("masters");
    if (mastersSession) {
      try {
        const parsedResponse = JSON.parse(mastersSession);
        const masters = parsedResponse;

        if (masters) {
          this.roleValue = masters.roles || [];
          this.prodCat = masters.productCategory || [];
          this.prodOut = masters?.outlets.map((o: any) => ({
            ...o,
            displayName: `${o.outlet_name} - ${o.outlet_code}`
          })) || [] || [];
          this.areaValue = masters.areas || [];
          this.regionValue = masters.regions || [];
          if (this.regionValue) {
            this.regionValue = this.regionValue.map((item: any) => {
              return {
                ...item,
                region_name: item?.state?.state_name
                  ? `${item.region_name} (${item?.state?.state_name})`
                  : item.region_name

              }

            })
          }
          console.log(this.prodOut, 'this.prodOut');
          console.log(this.prodCat, 'this.prodCat');
          console.log(this.roleValue, 'this.roleValue');


        }
      } catch (error) {

      }
    }
  }

  // onRoleChange(roleId: number) {

  // }

  onCategorySelect(item: any) {
    // const selectedCategories = this.userForm.get('product_category')?.value || [];
    // // Check if the category is already selected to avoid duplicates
    // const index = selectedCategories.findIndex((cat: any) => cat.id === item.id);
    // if (index === -1) {
    //   selectedCategories.push(item);
    // }
    // this.userForm.get('product_category')?.setValue(selectedCategories);
  }
  onCategoryDeSelect(item: any) {
    // const selectedCategories = this.userForm.get('product_category')?.value || [];
    // const index = selectedCategories.findIndex((cat: any) => cat.id === item.id);
    // if (index > -1) {
    //   selectedCategories.splice(index, 1);
    // }
    // this.userForm.get('product_category')?.setValue(selectedCategories);
  }

  filterProdCat() {
    console.log("this.prodCat>>>>: ", this.prodCat, "this.data.userData.outlet_id: ", this.data.userData)
    this.filteredProdCat = this.prodCat.filter((cat: any) => cat.outlet_id == this.data.userData.outlet_id).map((cat: any) => ({
      id: cat.category_id,
      product_category: cat.product_category,
    }));
    console.log(this.filteredProdCat, 'Filtered Product Categories');
  }

  categoryValue: any = []
  loadMSPINList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.usereditpopupservice.getUserList().subscribe(
      (response: any) => {
        if (response.responseCode === 200) {
          this.isLoading.next(false);
          // Access the mspins array from the response
          this.mspinList = response.data || [];  // Ensure it's initialized to an array          
          console.log(this.mspinList, 'this.mspinList');
        } else {
          this.isLoading.next(false);
        }
      },
      (error) => {
        this.isLoading.next(false);
        console.error('Error fetching MSPINs:', error); // Log error for debugging
      }
    );
  }

  onOutletChange(event: any) {
    const selectedOutletId = event.target.value;
    console.log("calling")
    if (selectedOutletId) {
      this.userForm.patchValue({ 'product_category': '' });
      this.filteredProdCat = this.prodCat.filter(
        (prodCat: any) => prodCat.outlet_id == parseInt(selectedOutletId)
      );
      this.filteredProdCat = this.filteredProdCat.map((cat: any) => ({
        id: cat.category_id,
        product_category: cat.product_category
      }));
    } else {
      this.filteredProdCat = [];
    }
  }
}
